/* global document */
import React from 'react';
import ReactDOM from 'react-dom';
import './antd-overrides.less';
import './index.scss';
import AppContainer from './AppContainer';
// import AppContainer from './AppPkg'; // For package testing

ReactDOM.render(<AppContainer />, document.getElementById('root'));
